import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { forgotPassword } from '../../services/api';

const ForgotPassword = () => {
  const [userEmail, setUserEmail] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleForgot = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const response = await forgotPassword(userEmail);
      setMessage(response.data.message || 'OTP sent to your email!');
      navigate('/reset-password-with-otp', { state: { email: userEmail } });
    } catch (error) {
      setMessage(error.response?.data?.message || 'Request failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-md rounded-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-semibold text-center mb-6">Forgot Password</h2>
        <form onSubmit={handleForgot} className="space-y-4">
          <input
            type="email"
            placeholder="Enter your email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            className="w-full border border-gray-300 px-4 py-2 rounded-md"
            required
          />
          <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700">
            Send OTP
          </button>
        </form>
        <p className="mt-4 text-sm text-center">
          <Link to="/" className="text-blue-600 hover:underline">Back to Login</Link>
        </p>
        {message && <p className="mt-4 text-center text-green-600">{message}</p>}
      </div>
    </div>
  );
};

export default ForgotPassword;